// extracted by mini-css-extract-plugin
export default {"contactAndIcons":"contactSection_contactAndIcons__5IwCa","contact":"contactSection_contact__KOWtj","iconList":"contactSection_iconList__lOX0S"};